function getCurrentLocale() {
  return Intl.DateTimeFormat().resolvedOptions().locale
}
export default getCurrentLocale